import createSvgIcon from '@mui/material/utils/createSvgIcon'

const Globe = createSvgIcon(
  <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.8248 18.0527C23.8248 22.8932 23.0375 27.212 21.8143 30.27C21.2012 31.8028 20.5055 32.951 19.8034 33.6934C19.1039 34.433 18.494 34.6777 17.9998 34.6777C17.5056 34.6777 16.8957 34.433 16.1963 33.6934C15.4941 32.951 14.7984 31.8028 14.1853 30.27C12.9621 27.212 12.1748 22.8932 12.1748 18.0527C12.1748 13.2123 12.9621 8.89346 14.1853 5.83547C14.7984 4.30267 15.4941 3.15451 16.1963 2.41204C16.8957 1.67247 17.5056 1.42773 17.9998 1.42773C18.494 1.42773 19.1039 1.67247 19.8034 2.41204C20.5055 3.15451 21.2012 4.30267 21.8143 5.83547C23.0375 8.89346 23.8248 13.2123 23.8248 18.0527Z"
      stroke="currentColor"
      strokeWidth="2.75"
    />
    <path
      d="M18 12.2274C22.8404 12.2274 27.1593 13.0147 30.2173 14.2379C31.7501 14.8511 32.8982 15.5467 33.6407 16.2489C34.3803 16.9483 34.625 17.5582 34.625 18.0524C34.625 18.5466 34.3803 19.1566 33.6407 19.856C32.8982 20.5582 31.7501 21.2538 30.2173 21.867C27.1593 23.0901 22.8404 23.8774 18 23.8774C13.1596 23.8774 8.84073 23.0901 5.78274 21.867C4.24993 21.2538 3.10177 20.5582 2.3593 19.856C1.61974 19.1566 1.375 18.5466 1.375 18.0524C1.375 17.5582 1.61974 16.9483 2.3593 16.2489C3.10177 15.5467 4.24993 14.8511 5.78274 14.2379C8.84073 13.0147 13.1596 12.2274 18 12.2274Z"
      stroke="currentColor"
      strokeWidth="2.75"
    />
  </svg>,
  'Globe'
)

export default Globe
